import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const SignUpLayer = () => {
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "http://localhost:5000/api/auth/signup",
        formData
      );
      setMessage(response.data.message);
      setFormData({ name: "", country: "", email: "", password: "" });
    } catch (error) {
      setMessage("Signup failed. Try again.");
    }
  };

  return (
    <div className="d-flex justify-content-center min-vh-100 bg-light">
      <section className="auth bg-base d-flex flex-wrap mt-5">
        <div className="py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <Link to="/" className="mb-40 max-w-290-px">
                <img src="assets/images/images/crebaco-logo.webp" alt="" />
              </Link>
              <h4 className="mb-12">Sign Up to your Account</h4>
              <p className="mb-32 text-secondary-light text-lg">
                Welcome back! Please enter your details
              </p>
            </div>
            {message && <p>{message}</p>}
            <form onSubmit={handleSubmit}>
              {/* Name Field */}
              <div className="icon-field mb-16">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="f7:person" />
                </span>
                <input
                  type="text"
                  name="name"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Country Field */}
              <div className="mb-16">
                <select
                  name="country"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  value={formData.country}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Country</option>
                  <option value="India">India</option>
                  <option value="USA">USA</option>
                  <option value="UK">UK</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {/* Email Field */}
              <div className="icon-field mb-16">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="mage:email" />
                </span>
                <input
                  type="email"
                  name="email"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Password Field */}
              <div className="mb-20 position-relative">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type="password"
                    name="password"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <span className="mt-12 text-sm text-secondary-light">
                  Your password must have at least 8 characters
                </span>
              </div>

              {/* Terms and Conditions Checkbox */}
              <div className="d-flex justify-content-between gap-2 mb-16">
                <div className="form-check style-check d-flex align-items-start">
                  <input
                    className="form-check-input border border-neutral-300 mt-4"
                    type="checkbox"
                    id="condition"
                    required
                  />
                  <label
                    className="form-check-label text-sm"
                    htmlFor="condition"
                  >
                    By creating an account, you agree to the
                    <Link to="#" className="text-primary-600 fw-semibold">
                      Terms & Conditions
                    </Link>{" "}
                    and our
                    <Link to="#" className="text-primary-600 fw-semibold">
                      Privacy Policy
                    </Link>
                  </label>
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                Sign Up
              </button>

              {/* Already Have an Account */}
              <div className="mt-32 text-center text-sm">
                <p className="mb-0">
                  Already have an account?{" "}
                  <Link to="/" className="text-primary-600 fw-semibold">
                    Sign In
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignUpLayer;
